export const SERVICE_DROPCONTROL = 1;
export const SERVICE_DATAPLAN = 2;
export const SERVICE_EXT_DATASOURCE = 3;
export const SERVICE_ADDITIONAL_USER = 4;
export const SERVICE_SMS_CALLS = 5;
export const SERVICE_IMAGES = 6;
export const SERVICE_ADDITIONAL_API = 7;
export const SERVICE_LIST= [1,2,3,4,5,6,7];
export const EXAMPLE_PRICE_LIST = {
    "lista_precio_id": 1,
    "nombre": "Testing Price List",
    "config_descuentos": [
        {
            "rangeMin": 1,
            "rangeMax": 5,
            "discount": 0,
            "includedUser": 4,
            "includedAPI": 1,
            "SMS": 1,
            "calls": 1
        },
        {
            "rangeMin": 6,
            "rangeMax": 10,
            "discount": 10,
            "includedUser": 6,
            "includedAPI": 1,
            "SMS": 10,
            "calls": 10
        },
        {
            "rangeMin": 11,
            "rangeMax": 15,
            "discount": 20,
            "includedUser": 8,
            "includedAPI": 2,
            "SMS": 20,
            "calls": 20
        },
        {
            "rangeMin": 16,
            "discount": 25,
            "includedUser": 12,
            "includedAPI": 3,
            "SMS": 50,
            "calls": 50
        }
    ],
    "precios": [
        {
            "lista_precio_id": 1,
            "servicio_id": 2,
            "config": null,
            "valor": 50
        },
        {
            "lista_precio_id": 1,
            "servicio_id": 6,
            "config": null,
            "valor": 5
        },
        {
            "lista_precio_id": 1,
            "servicio_id": 7,
            "config": {
                "farmAPI": 20,
                "clientAPI": 100
            },
            "valor": null
        },
        {
            "lista_precio_id": 1,
            "servicio_id": 4,
            "config": {
                "farmUser": 12,
                "clientUser": 50
            },
            "valor": null
        },
        {
            "lista_precio_id": 1,
            "servicio_id": 1,
            "config": {
                "DROPCONTROL": {
                    "EXP-X1": 12,
                    "EXP-M1": 10,
                    "EXP-C1": 25,
                    "FREE": 0
                },
                "API": {
                    "API-X1": 12,
                    "API-M1": 10,
                    "API-C1": 25
                },
                "FREE": {
                    "valor": "0"
                }
            },
            "valor": null
        },
        {
            "lista_precio_id": 1,
            "servicio_id": 5,
            "config": {
                "SMS": 50,
                "call": 100
            },
            "valor": null
        },
        {
            "lista_precio_id": 1,
            "servicio_id": 3,
            "config": {
                "3": 0,
                "4": 0,
                "6": 10,
                "11": 10,
                "12": 12,
                "13": 0,
                "14": {
                    "default": 12,
                    "arable": 1
                },
                "15": 0
            },
            "valor": 70
        }
    ],
    "servicios": [
        {
            "servicio_id": 2,
            "nombre": "DataPlan",
            "config": null
        },
        {
            "servicio_id": 6,
            "nombre": "Images",
            "config": null
        },
        {
            "servicio_id": 7,
            "nombre": "ApiKeys",
            "config": null
        },
        {
            "servicio_id": 4,
            "nombre": "User",
            "config": null
        },
        {
            "servicio_id": 1,
            "nombre": "Dropcontrol",
            "config": null
        },
        {
            "servicio_id": 5,
            "nombre": "SMS & Calls",
            "config": null
        },
        {
            "servicio_id": 3,
            "nombre": "External DataSource",
            "config": {
                "node_types": [
                    3,
                    4,
                    6,
                    11,
                    12,
                    13,
                    14,
                    15
                ]
            }
        }
    ]
};

export const SERVICE_DROPCONTROL_DROPCONTROL = "DROPCONTROL";
export const SERVICE_DROPCONTROL_LITE = "DROPCONTROL-LITE";
export const SERVICE_DROPCONTROL_PREMIUM = "DROPCONTROL-PREMIUM";
export const SERVICE_DROPCONTROL_API = "API";
export const SERVICE_DROPCONTROL_FREE = "FREE";

export const CONTRATO_MENSUAL = 1;
export const CONTRATO_TRIMESTAL = 2;
export const CONTRATO_ANUAL = 3;
export const CONTRATO_SEMESTRAL = 4;

export const TIPO_NODO_X1_GW = 1;
export const TIPO_NODO_X1 = 2;
export const TIPO_NODO_CIMIS = 3;
export const TIPO_NODO_FTP = 4;
export const TIPO_NODO_WT_DROP = 5;
export const TIPO_NODO_DAVIS = 6;
export const TIPO_NODO_C1 = 7;
export const TIPO_NODO_C1_GW = 8;
export const TIPO_NODO_M1 = 9;
export const TIPO_NODO_M1_GW = 10;
export const TIPO_NODO_PESSL = 11;
export const TIPO_NODO_JOHN_DEERE = 12;
export const TIPO_NODO_CROPCONNECT = 13;
export const TIPO_NODO_API_GEN = 14;
export const TIPO_NODO_ZENTRA_CLOUD = 14; //TODO Revisar numero Zentra

export const TIPO_SENSOR_SWITCH_RIEGO = 40;
export const LABEL_NODOS ={
    "1":"X1 GW",
    "2":"X1",
    "3":"CIMIS",
    "4":"FTP",
    "5":"WT_DROP",
    "6":"DAVIS",
    "7":"C1",
    "8":"C1 GW",
    "9":"M1",
    "10":"M1 GW",
    "11":"PESSL",
    "12":"JOHN DEERE",
    "13":"CROPCONNECT",
    "14":"API GEN",
    "15":"ZENTRA CLOUD"
};

export const fillNodesPlan = (farmService ,nodes, acceso_limitado) => {
    if (acceso_limitado)
        farmService = SERVICE_DROPCONTROL_FREE;
    for (const node of nodes) {
        switch (farmService) {
            case SERVICE_DROPCONTROL_FREE: {
                switch (node.tipo_nodo_id) {
                    case TIPO_NODO_C1:
                    case TIPO_NODO_C1_GW:
                    case TIPO_NODO_M1:
                    case TIPO_NODO_M1_GW:
                    case TIPO_NODO_X1:
                    case TIPO_NODO_X1_GW: {
                        node.contrato = "FREE";
                        continue;
                    }
                    default:{
                        break;
                    }
                }
                break;
            }
            case SERVICE_DROPCONTROL_API: {
                switch (node.tipo_nodo_id) {
                    case TIPO_NODO_C1:
                    case TIPO_NODO_C1_GW: {
                        node.contrato = "API-C1";
                        continue;
                    }
                    case TIPO_NODO_M1:
                    case TIPO_NODO_M1_GW: {
                        node.contrato = "API-M1";
                        continue;
                    }
                    case TIPO_NODO_X1:
                    case TIPO_NODO_X1_GW: {
                        node.contrato = "API-X1";
                        continue;
                    }
                    default:{
                        break;
                    }
                }
                break;
            }
            case SERVICE_DROPCONTROL_DROPCONTROL: {
                switch (node.tipo_nodo_id) {
                    case TIPO_NODO_C1:
                    case TIPO_NODO_C1_GW: {
                        node.contrato = "EXP-C1";
                        continue;
                    }
                    case TIPO_NODO_M1:
                    case TIPO_NODO_M1_GW: {

                        if (node.sensores.some(sen => sen?.monitorear /*&& sen.sist_tipo_sensor_id!=TIPO_SENSOR_SWITCH_RIEGO*/)) {
                            node.contrato = "EXP-M1";
                        } else {
                            node.contrato = "FREE";
                        }

                        continue;
                    }
                    case TIPO_NODO_X1:
                    case TIPO_NODO_X1_GW: {
                        if (node.sensores.some(sen => sen?.monitorear && sen?.sist_tipo_sensor_id !== TIPO_SENSOR_SWITCH_RIEGO)) {
                            node.contrato = "EXP-X1";
                        } else {
                            node.contrato = "FREE";
                        }
                        continue;
                    }
                    default:{
                        break;
                    }
                }
                break;
            }
            case SERVICE_DROPCONTROL_LITE: {
                switch (node.tipo_nodo_id) {
                    case TIPO_NODO_C1:
                    case TIPO_NODO_C1_GW: {
                        node.contrato = "LITE-C1";
                        continue;
                    }
                    case TIPO_NODO_M1:
                    case TIPO_NODO_M1_GW: {

                        if (node.sensores.some(sen => sen?.monitorear /*&& sen.sist_tipo_sensor_id!=TIPO_SENSOR_SWITCH_RIEGO*/)) {
                            node.contrato = "LITE-M1";
                        } else {
                            node.contrato = "FREE";
                        }

                        continue;
                    }
                    case TIPO_NODO_X1:
                    case TIPO_NODO_X1_GW: {
                        if (node.sensores.some(sen => sen?.monitorear && sen?.sist_tipo_sensor_id !== TIPO_SENSOR_SWITCH_RIEGO)) {
                            node.contrato = "LITE-X1";
                        } else {
                            node.contrato = "FREE";
                        }
                        continue;
                    }
                    default:{
                        break;
                    }
                }
                break;
            }
            case SERVICE_DROPCONTROL_PREMIUM:{
                switch (node.tipo_nodo_id) {
                    case TIPO_NODO_C1:
                    case TIPO_NODO_C1_GW: {
                        node.contrato = "PREM-C1";
                        continue;
                    }
                    case TIPO_NODO_M1:
                    case TIPO_NODO_M1_GW: {

                        if (node.sensores.some(sen => sen?.monitorear /*&& sen.sist_tipo_sensor_id!=TIPO_SENSOR_SWITCH_RIEGO*/)) {
                            node.contrato = "PREM-M1";
                        } else {
                            node.contrato = "FREE";
                        }

                        continue;
                    }
                    case TIPO_NODO_X1:
                    case TIPO_NODO_X1_GW: {
                        if (node.sensores.some(sen => sen?.monitorear && sen?.sist_tipo_sensor_id !== TIPO_SENSOR_SWITCH_RIEGO)) {
                            node.contrato = "PREM-X1";
                        } else {
                            node.contrato = "FREE";
                        }
                        continue;
                    }
                    default:{
                        break;
                    }
                }
                break;
            }
            default:{
                break;
            }
        }
    }
    return nodes;
};
export default {
    SERVICE_DROPCONTROL, SERVICE_DATAPLAN, SERVICE_EXT_DATASOURCE, SERVICE_ADDITIONAL_USER, SERVICE_SMS_CALLS, SERVICE_IMAGES, SERVICE_ADDITIONAL_API,
    CONTRATO_MENSUAL, CONTRATO_TRIMESTAL, CONTRATO_ANUAL, CONTRATO_SEMESTRAL,
    TIPO_NODO_X1_GW, TIPO_NODO_X1, TIPO_NODO_CIMIS, TIPO_NODO_FTP, TIPO_NODO_WT_DROP, TIPO_NODO_DAVIS, TIPO_NODO_C1, TIPO_NODO_C1_GW,
    TIPO_NODO_M1, TIPO_NODO_M1_GW, TIPO_NODO_PESSL, TIPO_NODO_JOHN_DEERE, TIPO_NODO_CROPCONNECT, TIPO_NODO_API_GEN, TIPO_NODO_ZENTRA_CLOUD,
    SERVICE_DROPCONTROL_DROPCONTROL, SERVICE_DROPCONTROL_API, SERVICE_DROPCONTROL_FREE, LABEL_NODOS, TIPO_SENSOR_SWITCH_RIEGO,
    fillNodesPlan
};
